import React from 'react';
import { Box, Typography } from '@mui/material';
import PaymentGatewaySelector from '../../../../../Components/finance/Components/PaymentGatewaySelector';

const GatewayStep = ({ amount, selectedGateway, onGatewaySelect }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 1 }}>
        Select Payment Gateway
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Choose your preferred payment method
      </Typography>

      <PaymentGatewaySelector
        amount={amount}
        selectedGateway={selectedGateway?.gatewayId}
        onGatewaySelect={onGatewaySelect}
      />
    </Box>
  );
};

export default GatewayStep;
